import { FC } from 'react';

import Link from 'next/link';

import { StyledOutlineButton, StyledPrimaryButton } from './styled';

export interface IButtonLink {
  variant?: 'primary' | 'outline';
  icon: 'SFCreditCard' | 'CardGiftIcon';
  label: string;
  href: string;
}

const variants = {
  primary: StyledPrimaryButton,
  outline: StyledOutlineButton,
};

const ButtonLink: FC<IButtonLink> = ({ variant = 'primary', label, href }) => {
  const Button = variants[variant];

  return (
    <Link prefetch={false} href={href} passHref>
      <Button {...(variant === 'primary' && { type: 'primary' })}>
        {label}
      </Button>
    </Link>
  );
};

export default ButtonLink;
